import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/close.svg'
import _imports_1 from '@/assets/images/zip_conveyancing.png'
import _imports_2 from '@/assets/icons/checkcircle.svg'
import _imports_3 from '@/assets/icons/chevron-right-gray.svg'


const _hoisted_1 = { class: "dont-have-solicitor-container" }
const _hoisted_2 = { class: "features-container" }
const _hoisted_3 = { class: "subtitle-2" }
const _hoisted_4 = { class: "options-wr" }
const _hoisted_5 = { class: "disclaimer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "close-button",
      src: _imports_0,
      onClick: $setup.close
    }),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title-container" }, [
      _createElementVNode("img", {
        class: "img-zip",
        src: _imports_1,
        alt: "zip-image"
      }),
      _createElementVNode("div", { class: "recommended-subtitle" }, "RECOMMENDED")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.features, (feat) => {
        return _createElementVNode("div", {
          class: "feature",
          key: feat
        }, [
          _createElementVNode("img", {
            class: "check-circle",
            src: _imports_2,
            onClick: $setup.close
          }),
          _createElementVNode("h4", _hoisted_3, _toDisplayString(feat), 1)
        ])
      }), 64))
    ]),
    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"url-container\" data-v-21b58750><a class=\"url-wr\" href=\"https://www.zipconveyancing.com.au/\" target=\"_blank\" data-v-21b58750><div class=\"url\" data-v-21b58750>zipconveyancing.com.au</div><img class=\"rigth-chevron\" src=\"" + _imports_3 + "\" alt=\"chevron-right-icon\" data-v-21b58750></a></div><div class=\"divider\" data-v-21b58750></div><div class=\"nominate-question\" data-v-21b58750><p data-v-21b58750>Would you like to nominate Zip Conveyancing to act as your solicitor and request that they contact you to discuss your land purchase and their services?</p></div>", 3)),
    _createElementVNode("div", _hoisted_4, [
      _createVNode($setup["GreenButton"], {
        title: 'Yes, nominate Zip Conveyancing',
        active: !$setup.props.haveOwnSolicitor || $setup.activeDefault,
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateDontHaveOwnSolicitor()))
      }, null, 8, ["active"]),
      _createVNode($setup["GreenButton"], {
        title: 'No, I have my own solicitor',
        active: $setup.props.haveOwnSolicitor && !$setup.activeDefault,
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateHaveOwnSolicitor()))
      }, null, 8, ["active"])
    ]),
    _createElementVNode("div", _hoisted_5, "DISCLAIMER: This information about third-party services is for the convenience of our clients. Please note that these third-party services are independent entities and are not affiliated with or endorsed by " + _toDisplayString($props.estateTitle) + ". We encourage clients to conduct their own research and due diligence before engaging with any third-party service", 1)
  ]))
}